<template>
    <div class="service-review-details">
        <section v-if="provider" class="review-statistics" aria-label="当前服务者专业统计">
            <h3>{{ providerLabel }}专业统计</h3>
            <dl>
                <div><dt>平均评分</dt><dd>{{ provider.averageScore == null ? '暂无评价' : Number(provider.averageScore).toFixed(1) + ' / 5' }}</dd></div>
                <div><dt>评价数</dt><dd>{{ provider.reviewCount }}</dd></div>
                <div><dt>正常完成单数</dt><dd>{{ provider.completedOrderCount }}</dd></div>
            </dl>
            <button v-if="reviewRoute" type="button" class="review-list-entry" @click="$router.push(reviewRoute)">查看全部匿名评价</button>
        </section>
        <section v-if="summary" class="order-review" aria-label="本单评价">
            <h3>本单评价</h3>
            <p class="review-state">{{ statusText }}</p>
            <template v-if="pending">
                <p v-if="summary.paused">评价计时已暂停<span v-if="summary.remainingSeconds != null">，剩余 {{ summary.remainingSeconds }} 秒</span>；争议结束后恢复计时。</p>
                <p v-else-if="summary.deadlineAt">评价截止：{{ summary.deadlineAt }}（上海时间）</p>
                <p v-if="summary.status === 0 && summary.canAutoReview">正常评价期限为七天；{{ summary.paused ? '计时恢复后，按剩余时间' : '' }}到期未评价将自动五星好评。</p>
            </template>
            <div v-if="summary.status === 1 && summary.review" class="anonymous-review">
                <p class="review-author"><span class="anonymous-avatar" aria-hidden="true">匿</span>匿名用户</p>
                <p :aria-label="'评分 ' + summary.review.score + ' 分，满分 5 分'">{{ summary.review.score }} / 5</p>
                <p class="review-text">{{ summary.review.displayText }}</p>
                <p v-if="summary.review.reviewedAt">{{ summary.review.reviewedAt }}</p>
                <ServiceReviewImages v-if="summary.review.images && summary.review.images.length" :key="summary.review.reviewId" :review-id="summary.review.reviewId" :images="summary.review.images" @refresh="$emit('refresh')" />
            </div>
        </section>
    </div>
</template>
<script>
import ServiceReviewImages from '@/components/photography/ServiceReviewImages.vue';
export default {
    name: 'ServiceReviewDetails',
    components: { ServiceReviewImages },
    props: { provider: { type: Object, default: null }, summary: { type: Object, default: null }, providerLabel: { type: String, default: '当前服务者' } },
    computed: {
        reviewRoute() {
            if (!this.provider) return null;
            const type = ({ PHOTOGRAPHER: '1', MAKEUP_ARTIST: '2', 1: '1', 2: '2' })[this.provider.professionalType];
            // The legacy user professionalId may already have lost integer precision.
            const userProvider = ['PHOTOGRAPHER', 'MAKEUP_ARTIST'].includes(this.provider.professionalType);
            const id = userProvider ? this.provider.reviewProfessionalId : this.provider.professionalId;
            if (!type || typeof id !== 'string' || !/^[1-9]\d*$/.test(id)) return null;
            return { name: 'professionalReviews', params: { professionalType: type, professionalId: id } };
        },
        pending() { return this.summary && [0, 2].includes(this.summary.status); },
        statusText() { return ({ 0: '待评价', 1: '已评价', 2: '待评价', 3: '评价已删除', 4: '评价已过期' })[this.summary.status] || this.summary.statusText; },
    },
};
</script>
<style scoped>
.service-review-details { min-width:0; color:#51455b; font-size:14px; line-height:1.6; overflow-wrap:anywhere; }
.review-statistics,.order-review { margin:14px 0; padding:14px; border:1px solid #eee7f0; border-radius:10px; background:#faf8fb; }
.service-review-details h3 { margin:0 0 10px; color:#332d49; font-size:14px; }
.review-statistics dl { display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:12px; margin:0; }
.review-statistics dt { color:#66596f; font-size:12px; }
.review-statistics dd { margin:5px 0 0; color:#332d49; font-size:14px; font-weight:700; }
.order-review p { margin:8px 0; }.review-state { font-weight:700; }.review-text { white-space:pre-wrap; }
.review-author { display:flex; align-items:center; gap:8px; }.anonymous-avatar { display:inline-grid; place-items:center; width:32px; height:32px; border-radius:50%; background:#eee8f0; color:#66596f; }
.review-images { display:flex; flex-wrap:wrap; gap:8px; }.review-images img { width:88px; height:88px; max-width:100%; object-fit:cover; border-radius:6px; }
@media(max-width:480px) { .review-statistics dl { gap:8px; }.review-statistics,.order-review { padding:12px; } }
.review-list-entry { min-height:44px; margin-top:12px; padding:8px 14px; border:1px solid #c8b6d5; border-radius:7px; background:#fff; color:#624385; cursor:pointer; font:inherit; }
.review-list-entry:hover { background:#eee8f0; }.review-list-entry:focus-visible { outline:3px solid #76528e; outline-offset:3px; }
</style>
